<template>
  <anchor-modal
    v-model="display"
    width="30%"
    title="Add New Domain"
    light
    header-color="white"
    :header-split="true"
  >
    <domains-form
      ref="domainForm"
      @cancel="() => display = false"
      @success="successHandler"
    />
  </anchor-modal>
</template>

<script>
import DomainsForm from '@/components/admin/controls/domains/form/DomainsForm';


export default {
  name: 'AdminDomainsModalForm',
  components: {
    DomainsForm,
  },
  data: () => ({
    display: false,
  }),
  methods: {
    open() {
      this.display = true;
      this.$nextTick(() => {
        this.$refs.domainForm.reset();
      });
    },
    successHandler() {
      this.$emit('success');
      this.display = false;
    },
  },
};
</script>
